import { NavGroup } from "./nav-group";
import { navGroupLabels, tertiaryNav } from "@/constants/nav.constants";
import { useVisibleNav } from "@/features/navigation/hooks/use-visible-nav";
import { m } from "@/paraglide/messages.js";

/** A third, optional nav block for packs that register tertiary entries. */
export function NavProjects() {
  const visibleNav = useVisibleNav(tertiaryNav);

  return <NavGroup label={navGroupLabels.tertiary ?? m.layout_nav_group_tertiary()} entries={visibleNav} />;
}
